﻿import $ from "jquery";
import c from "./consts";

import Microsoft365 from "./Microsoft365";

export default class Microsoft365PromoTwentyDollars extends Microsoft365 {
	constructor(o, $ep) {
		super(...arguments);

		this.promo = o.promo;

		this.$contents = $ep.find(c.contentsSelector);
		this.$footer = this.renderFooter();

		this.$container = $(`.${c.promoContainerClass}`)
			.attr(c.promoBannerShowAttr, o.promo.showPopup)
			.prependTo(this.$footer);

		const $prices = $ep.find(c.priceSelector);
		this.applyDiscount($prices);

		this.renderPromoElements();
		this.initPromoEvents();

		this.$ep.attr(c.wrapperPromoAttr, true);
	}

	renderFooter() {
		const footerHtml =
			`<div class="ccs-logo-ms365-footer">
	<div class="${c.promoContainerClass}"></div>
	<div class="${c.footerTextClass}">${this.promo.footerText}</div>
</div>`;

		return $(footerHtml).appendTo(this.$contents);
	}

	applyDiscount($elements) {
		const _ = this;

		$.each($elements, (i, el) => {
			const $el = $(el),
				price = $el.text().trim();

			if (price.length === 0)
				return;

			const discountPrice = _.getDiscountPrice(price, _.promo.discountValue);
			if (!discountPrice)
				return;

			$el.empty()
				.append(`<div class="ccs-ms365-current-price">${price}</div>`)
				.append(`<div class="ccs-ms365-promo-price">${discountPrice}</div>`);
		});
	}

	getDiscountPrice(priceString, discount) {
		priceString = priceString.replace(",", ".");
		const number = priceString.match(/\d+\.\d+|\d+/);

		if (!number)
			return "";

		if (!discount)
			return priceString;

		let price;

		if (!discount.relative) {
			price = number - discount.absolute;
		} else {
			price = number * (1 - discount.relative);
		}

		if (price % 1 !== 0) {
			price = price.toFixed(2);
		}

		if (price <= 0)
			return false;

		return priceString.replace(number, price);
	}

	renderPromoElements() {
		const _ = this;

		const $banner = _.renderBanner(c.bannerClasses, _.promo.bannerTexts);
		$banner.appendTo(_.$container);

		if (!_.promo.showPopup)
			return;

		const $popup = _.renderPopup(c.popupClasses, _.promo.popupTexts);
		$popup.appendTo(_.$contents.parent());

		_.renderFakeATC();
	}

	renderBanner(classes, texts) {
		const bannerHtml =
			`<div class="${classes.banner}" tabindex="0" role="button">
	<div class="${classes.top}">${texts.top}</div>
	<div class="${classes.bottom}">${texts.bottom}</div>
</div>`;

		return $(bannerHtml);
	}

	renderPopup(classes, texts) {
		const popupHtml =
			`<div class="${classes.popup}">
	<div class="${classes.modalWindow}">
		<div class="${classes.closeBtn}" tabindex="0" role="button"></div>
		<div class="${classes.content}">
			<div class="${classes.title}">${texts.title}</div>
			<input aria-label="${texts.couponCode}" class="${classes.couponCode}" value="${texts.couponCode}" type="text" readonly contenteditable="false">
			<div class="${classes.description}">${texts.description}</div>
			<a class="${classes.copyCodeBtn}" href="#" role="button">${texts.copyCodeBtn}</a>
		</div>
		<div class="${classes.picture}"></div>
	</div>
</div>`;

		return $(popupHtml);
	}

	renderFakeATC() {
		const _ = this,
			$atc = _.$ep.find(c.addToCartSelector);

		if ($atc.length === 0)
			return;

		const $fakeAddToCard = $("<div>").addClass(c.fakeAddToCartClass);

		$atc.before($fakeAddToCard);
	}

	initPromoEvents() {
		const _ = this;

		_.$ep.on("click", `.${c.popupClasses.copyCodeBtn}`, () => _.logEventPromo());

		_.$ep.on("keypress", `.${c.popupClasses.copyCodeBtn}`, e => {
			if (e.keyCode === 13) {
				_.logEventPromo();
			}
		});

		_.$ep.on("click", `[${c.promoBannerShowAttr}]`, () => _.showPopup());

		_.$ep.on("keypress", `[${c.promoBannerShowAttr}]`, e => {
			if (e.keyCode === 13) {
				_.showPopup();
			}
		});

		_.$ep.on("click", `.${c.popupClasses.closeBtn}`, e => _.closePopup($(e.target)));

		_.$ep.on("keypress", `.${c.popupClasses.closeBtn}`, e => {
			if (e.keyCode === 13) {
				_.closePopup($(e.target));
			}
		});

		_.$ep.on("click", `.${c.fakeAddToCartClass}`, e => {
			_.showPopup();
			_.showPopupOnAddToCartClick($(e.target));
		});

		_.$ep.on("keypress", `.${c.fakeAddToCartClass}`, e => {
			if (e.keyCode === 13) {
				_.showPopup();
				_.showPopupOnAddToCartClick($(e.target));
			}
		});

		_.$ep.on("click", `.${c.popupClasses.copyCodeBtn}`, e => {
			_.copyCodeToClipboard();
			_.closePopup($(e.target));
		});

		_.$ep.on("keypress", `.${c.popupClasses.copyCodeBtn}`, e => {
			if (e.keyCode === 13) {
				_.copyCodeToClipboard();
				_.closePopup($(e.target));
			}
		});

		_.$ep.on("ccsPrice.success", c.priceSelector, e => _.applyDiscount($(e.target)));
	}

	logEventPromo() {
		const _ = this,
			clientParams = {
				Action: "click",
				ActionContext: "copy-to-clipboard"
			};

		ccs_cc_log.dispatchEvent(_.o.logEvent, clientParams);
	}

	showPopup() {
		this.$ep.find(`.${c.popupClasses.popup}`).addClass(c.popupClasses.show);
	}

	showPopupOnAddToCartClick(el) {
		const _ = this,
			$el = $(el);

		_.$ep.find(`.${c.popupClasses.closeBtn}`)
			.off("click.ccs_Microsoft365Promo")
			.one("click.ccs_Microsoft365Promo",
				function (e) {
					_.triggerClickToATC($el);
					_.closePopup($(e.target));
				}
			);

		_.$ep.find(`.${c.popupClasses.copyCodeBtn}`)
			.off("click.ccs_Microsoft365Promo")
			.one("click.ccs_Microsoft365Promo",
				function (e) {
					e.stopPropagation();

					_.copyCodeToClipboard();
					_.triggerClickToATC($el);
					_.closePopup($(e.target));
				}
			);
	}

	closePopup($el) {
		$el.closest(`.${c.popupClasses.popup}`).removeClass(c.popupClasses.show);
	}

	triggerClickToATC($fakeAtcBtn) {
		const $atcButtonContainer = $fakeAtcBtn.next();
		const atcSelector = $atcButtonContainer.find("input[type=submit]").length
			? "input[type=submit]"
			: "a, button";

		const atcButton = $atcButtonContainer.find(atcSelector)[0];
		if (!atcButton)
			return;

		atcButton.click();
	}

	copyCodeToClipboard() {
		const _ = this;
		const $couponCode = _.$ep.find(`.${c.popupClasses.couponCode}`);

		$couponCode.focus().select();

		const success = document.execCommand("copy");
		if (!success) {
			_.iosCopyFallback($couponCode);
		}

		$couponCode.blur();
	}

	iosCopyFallback($couponCode) {
		const couponCode = $couponCode[0];

		const editable = couponCode.contentEditable;
		const readOnly = couponCode.readOnly;

		couponCode.contentEditable = true;
		couponCode.readOnly = true;

		const range = document.createRange();
		range.selectNodeContents(couponCode);

		const selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);

		couponCode.setSelectionRange(0, 999999);

		couponCode.contentEditable = editable;
		couponCode.readOnly = readOnly;

		document.execCommand("copy");
	}
}
